module.exports = __webpack_public_path__ + "static/media/p6.8ee17724.jpg";